import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { WEB_SERVICE_MIMS, pathHomePage } from "../../../../config/constants";
// Components
import Axios from "../../../../config/axios";
import { DeletePatientDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";

const DeletePatient = ({ setIsShowDeletePatient, patientId, patientVersion }) => {
  const [redirect, setRedirect] = useState(false);

  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const [t] = useTranslation("global");

  const handleSetShowDeletePatient = (e) => {
    e.preventDefault();
    setIsShowDeletePatient(false);
  };
  const handleDeletePatient = (e) => {
    e.preventDefault();
    const URL = `${WEB_SERVICE_MIMS}/patients/delete/${patientId}/${patientVersion}`;
    Axios("put", URL)
      .then(({ data }) => {
        if (data.deletedPatient) {
          toast.success(t("deletePatient.deletedPatientMessage"));
          setRedirect(true);
        } else {
          toast.error(t("profileMessage.sendDataMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("deletePatient.errorMessage"));
        console.log("url error: ", error);
      });
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}/home/${clinicianToken}`} />;
  }

  return (
    <DeletePatientDiv>
      <DeleteText>{t("deletePatient.deletePatientText")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={handleSetShowDeletePatient}>{t("deletePatient.backButton")}</BackButton>
        <DeleteButton onClick={handleDeletePatient}>{t("deletePatient.deleteButton")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeletePatientDiv>
  );
};

export default DeletePatient;
